<div class="motif-row">
  <div class="motif-col-xs-7 motif-col-sm-7 motif-col-md-7 motif-col-lg-9">
    <motif-select
      [(ngModel)]="selectedAsset"
      (ngModelChange)="onValueChange($event)"
      [disabled]="isDisabled"
      [ngClass]="{ 'disabled-motif-button': isDisabled }"
      placeholder="Select Asset"
    >
      <motif-option *ngFor="let asset of assets" value="{{ asset }}">{{
        asset
      }}</motif-option>
    </motif-select>
  </div>
  <!--     <div class="motif-col-xs-5  motif-col-sm-5 motif-col-md-5 motif-col-lg-3">
        <motif-icon [iconFunction]="saveIcon" (click)="save()" [ngClass]="{'disabled-motif-button': isDisabled}"> </motif-icon>
    </div> -->
</div>
